<template>
  <div>
    <div class="sign-content">
      <el-card-title :title="title" />
      <el-form label-width="80px" :model="cooperationForm" :rules="cooperationFormRules" ref="cooperationFormRef">
        <el-form-item :label="$t('page.hisCooperation.contentLabel.cooperationCompany')" label-width="420px" prop="cooperEnterprise">
          <!-- 合作企业 -->
          <el-input :placeholder="$t('page.hisCooperation.inputPlc.cooperationCompanyMsg')" type="textarea" style="height: 78px"
                    v-model="cooperationForm.cooperEnterprise" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.hisCooperation.contentLabel.cooperationPerformance')" label-width="420px">
          <!-- 与中交合作业绩 -->
          <el-input :placeholder="$t('page.hisCooperation.inputPlc.input')" type="textarea" style="height: 78px"
            v-model="cooperationForm.cooperPerformIccec" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.hisCooperation.contentLabel.peerCooperation')" label-width="420px">
          <!-- 与同行业企业合作业绩 -->
          <el-input :placeholder="$t('page.hisCooperation.inputPlc.input')" type="textarea" style="height: 78px"
            v-model="cooperationForm.cooperPerformSameInd" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.hisCooperation.contentLabel.remark')" label-width="420px">
          <!-- 备注 -->
          <el-input :placeholder="$t('page.hisCooperation.inputPlc.input')" type="textarea" style="height: 78px"
            v-model="cooperationForm.remark" maxlength="500" show-word-limit></el-input>
        </el-form-item>
<!--        <el-card-title :title="title1" />-->
<!--        <el-button icon="icon-ccui-add" type="add-button" class="addbtn" @click="addCooperation">添加企业</el-button>-->
<!--        <el-table :data="tableData" border>-->
<!--          <el-table-column label="序号" width="50" type="index"></el-table-column>-->
<!--          <el-table-column label="合作企业" prop="cooperation">-->
<!--            <template v-slot="{row}">-->
<!--              <el-input v-model="row.cooperation" maxlength="500" show-word-limit class="cooperation"></el-input>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column label="操作" width="50">-->
<!--            <template v-slot="{row}">-->
<!--              <el-button type="text" @click="handleRemove(row)">删除</el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--        </el-table>-->
      </el-form>
    </div>
    <div class="btnBox">
      <el-button class="left-btn btn" size="mini" type="primary-icon-medium" @click="back()">
        <span>{{ $t('basicLayout.btn')[0] }}</span>
      </el-button>
      <el-button class="right-btn btn" size="mini" type="primary-icon-medium" @click="next()">
        <span>{{ $t('basicLayout.btn')[1] }}</span>
      </el-button>
    </div>
  </div>
</template>

<script>
  import {
    saveSupplierRegistInfo,
    qrySupRegistHisPerform
  } from '@/api/supRegister'
  import {
    mapActions
  } from 'vuex'
  import Cookies from "js-cookie";
  export default {
    name: "historyCooperation",
    data() {
      return {
        title: window.$t('page.hisCooperation.contentTitle.hisCooperation'), // 历史合作业绩
        title1: '合作企业 *',
        // 表单数据
        cooperationForm: {
          cooperEnterprise: '',
          cooperPerformIccec: '',
          cooperPerformSameInd: '',
          remark: '',
        },
        // 表单校验规则
        cooperationFormRules: {
          cooperEnterprise: [{
            required: true,
            message: window.$t('page.hisCooperation.inputPlc.cooperationCompanyMsg'),
            trigger: 'blur'
          }],

        },
        tableData: [],
        supInfoApplyId: ''
      }
    },
    created() {
      if(this.$route.query.page) {
        this.changeCheckPage(8)
      }
      if (Cookies.get('access_token') || this.$route.query.tempSupinfoId) {
        this.getSupRegistHisPerform()
      }
      if (this.$route.path == '/maPerfectInfo/historyCooperation') {
        this.changeCheckPage(8);
        for (let i = 0; i < 5; i++) {
          this.msgCenter.$emit('ballMoveRight')
        }
      }
    },
    methods: {
      ...mapActions(["changeCheckPage"]),
      back() {
        this.changeCheckPage(7)
        this.$router.push({path:'/maPerfectInfo/financialInformation',query:{tempSupinfoId: this.$route.query.tempSupinfoId}})
      },
      next() {
        // this.$emit('next')
        // if (this.tableData.length > 0) {
        //   this.$refs.cooperationFormRef.validate(valid => {
        //     this.tableData.forEach(async item => {
        //       if (valid && item.cooperation) {
        //         console.log(this.tableData)
        //         if (this.tableData.length === 0) {
        //           this.cooperationForm.cooperEnterprise = ''
        //         } else {
        //           this.cooperationForm.cooperEnterprise += item.cooperation+','
        //         }
        //         try {
        //           const {
        //             data
        //           } = await saveSupplierRegistInfo({
        //             dataSourceFlag: 0,
        //             isOverseas: 0,
        //             tempSupinfoId: this.supInfoApplyId,
        //             saveOrCommitFlag: '2',
        //             supRegistTab: '9',
        //             supRegistHisPerformBO: this.cooperationForm
        //           })
        //           console.log(data)
        //
        //           if (data.code === '0') {
        //             this.changeCheckPage(9)
        //             this.$router.push({path:'/maPerfectInfo/qualificationDocuments',query:{tempSupinfoId: this.$route.query.tempSupinfoId}})
        //           } else {
        //             this.$message.error('请添加合作企业');
        //           }
        //
        //         } catch (err) {
        //           console.log(data.message)
        //         }
        //       } else {
        //         this.$message.error('请添加合作企业');
        //         setTimeout(() => {
        //           const isError = document.getElementsByClassName('is-error');
        //           isError[0].querySelector('input').focus();
        //         }, 100)
        //         return false
        //       }
        //     })
        //   })
        // } else {
        //   this.$message.error('请添加合作企业');
        // }
        this.$refs.cooperationFormRef.validate(valid => {
          if(valid) {
            saveSupplierRegistInfo({
              dataSourceFlag: 0,
              isShowLoading:true,
              isOverseas: 0,
              tempSupinfoId: this.supInfoApplyId,
              saveOrCommitFlag: '2',
              supRegistTab: '9',
              // supRegistAccountInfoBO:{
              //   countyCode:sessionStorage.getItem('countyCode'),
              //   countyName:sessionStorage.getItem('countyName'),
              // },
              supRegistHisPerformBO: this.cooperationForm
            }).then(res => {
              if(res.data.code === '0') {
                this.changeCheckPage(9)
                this.$router.push({path:'/maPerfectInfo/qualificationDocuments',query:{tempSupinfoId: this.$route.query.tempSupinfoId}})
              }
            })
          } else {
            setTimeout(() => {
              const isError = document.getElementsByClassName('is-error');
              isError[0].querySelector('input').focus();
            },100)
          }
        })
      },
      // 删除
      // handleRemove(row) {
      //   console.log(row)
      //   this.tableData = this.tableData.filter(item => {
      //     return item.id != row.id
      //   })
      //   console.log(this.tableData)
      // },
      // 添加
      // addCooperation() {
      //   let id
      //   if (this.tableData.length === 0) {
      //     id = this.tableData.length + 1
      //   } else {
      //     id = this.tableData[this.tableData.length - 1].id + 1
      //   }
      //   const obj = {
      //     id: id,
      //     cooperation: ''
      //   }
      //   this.tableData.push(obj)
      //   console.log(this.tableData)
      // },
      // changeValue(row) {
      //   const str = row.cooperation
      //   this.cooperationForm.cooperEnterprise += str + ','
      //   console.log(this.cooperationForm);
      // },
      // 获取历史合作业绩
      // async getSupRegistHisPerform() {
      //   const {
      //     data
      //   } = await qrySupRegistHisPerform({
      //     tempOrFormalFlag: 0,
      //     supInfoApplyId: this.$route.query.tempSupinfoId
      //   })
      //   console.log(data)
      //   if (data.code === '0') {
      //     // this.cooperationForm.cooperEnterprise = data.data.supRegistHisPerformBO.cooperEnterprise
      //     this.cooperationForm.cooperPerformIccec = data.data.supRegistHisPerformBO.cooperPerformIccec
      //     this.cooperationForm.cooperPerformSameInd = data.data.supRegistHisPerformBO.cooperPerformSameInd
      //     this.cooperationForm.remark = data.data.supRegistHisPerformBO.remark
      //     this.supInfoApplyId = data.data.supInfoApplyId
      //     if (data.data.supRegistHisPerformBO.cooperEnterprise === '') {
      //       return
      //     } else {
      //       console.log(this.cooperationForm.cooperEnterprise.substring(0, this.cooperationForm.cooperEnterprise
      //         .length - 1).split(','))
      //       const arr = data.data.supRegistHisPerformBO.cooperEnterprise.substring(0, data.data.supRegistHisPerformBO.cooperEnterprise
      //         .length - 1).split(',')
      //       for (let i = 0; i <= arr.length - 1; i++) {
      //         const obj = {
      //           id: i,
      //           cooperation: arr[i]
      //         }
      //         this.tableData.push(obj)
      //       }
      //     }
      //   }
      // }
      async getSupRegistHisPerform() {
        const {
          data
        } = await qrySupRegistHisPerform({
          tempOrFormalFlag: this.$route.query.tempOrFormalFlag?this.$route.query.tempOrFormalFlag:0,
          supInfoApplyId: this.$route.query.tempSupinfoId,
          isShowLoading:true,
        })
        console.log(data)
        if (data.code === '0') {
          this.cooperationForm.cooperEnterprise = data.data.supRegistHisPerformBO.cooperEnterprise
          this.cooperationForm.cooperPerformIccec = data.data.supRegistHisPerformBO.cooperPerformIccec
          this.cooperationForm.cooperPerformSameInd = data.data.supRegistHisPerformBO.cooperPerformSameInd
          this.cooperationForm.remark = data.data.supRegistHisPerformBO.remark
          this.supInfoApplyId = data.data.supInfoApplyId
        }
      }
    }
  }

</script>

<style scoped lang="scss">
  .sign-content {
    width: 1180px;
    background: #FFFFFF;
    margin: 20px auto;
    overflow: hidden;

    .el-card-title {
      /deep/ .details-title {
        color: black;
        border-bottom: 0px;
        top: 20px;
        margin-left: 230px;
      }
    }

    .el-form {
      margin-top: 20px;
      //margin-left: 250px;
      position: relative;

      .el-textarea {
        margin-left: 6px;
        width: 430px;
        border-radius: 4px;
        /deep/ .el-textarea__inner {
          height: 58px;
        }
      }

      .el-table {
        width: 585px;
        margin: 40px auto;

        /deep/ .el-table__row {
          .el-input {
            input {
              background-color: #f1f1f1 !important;
              color: #9b9b9b !important;
            }
          }
          .cooperation .el-input__inner {
            padding-right: 60px;
          }
        }
      }

      .addbtn {
        position: absolute;
        left: 790px;

        /deep/ .icon-ccui-add {
          margin-right: 10px;
          color: #ff142f;
        }

        /deep/ span {
          color: #ff142f;
        }
      }

    }
  }

  .btn {
    width: 240px;
    height: 40px;
    background: #FF142F;
    margin-bottom: 20px;

    span {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFangSC;
      font-weight: 600;
    }
  }

  .btnBox {
    margin: 0px auto;
    width: 500px;
  }

  .cooperationRuls {
    .el-form-item__error {
      width: 100%;
      text-align: center;
    }
  }

</style>
